// 26 §3.2 permission matrix (the rows the Stage 0 console uses). Hiding a
// control is never the protection: the server checks every command (ADM-004).

export type AdminRole = 'owner' | 'moderator' | 'support' | 'analyst';

export type Capability =
  | 'view_dashboards'
  | 'propose_config'
  | 'approve_fair_config'
  | 'admin_users'
  | 'simulation'
  | 'round_inspector'
  | 'course_review';

export interface Rule {
  roles: readonly AdminRole[];
  stepUp: boolean;
  reason: boolean;
}

export const MATRIX: Record<Capability, Rule> = {
  view_dashboards: {
    roles: ['owner', 'moderator', 'support', 'analyst'],
    stepUp: false,
    reason: false,
  },
  propose_config: { roles: ['owner'], stepUp: false, reason: true },
  approve_fair_config: { roles: ['owner'], stepUp: true, reason: true },
  admin_users: { roles: ['owner'], stepUp: true, reason: true },
  // ADM-102, the row for 10: the screen "Simulation" is the owner's; an analyst reads the dashboards
  // that ADM-102 names (the permission row of the sixth rulings). Proposing from its parameter
  // editor is propose_config, the owner's.
  simulation: { roles: ['owner', 'analyst'], stepUp: false, reason: false },
  // ADM-102, the row "The round inspector": owner; support reads a finished round with a reason.
  // This build asks every role for a reason (decision record 0071).
  round_inspector: { roles: ['owner', 'support'], stepUp: false, reason: true },
  // ADM-041 and 26 §3.2's row "Course and flagship review" (07 CRS-037): the owner's, a reason for each action.
  course_review: { roles: ['owner'], stepUp: false, reason: true },
};

export function can(role: AdminRole, cap: Capability): boolean {
  return MATRIX[cap].roles.includes(role);
}
